<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      :mini-variant="mini && !$vuetify.breakpoint.smAndDown"
      mini-variant-width="68"
      color="#26312f"
      app
      v-if="usuarioLogado"
    >
      <div class="av-brand">
        <img class="av-brand-full" src="../assets/logoAvalizeHorizontalBranca.png" alt="Avalize" style="height: 30px; width: auto; max-width: 86%;">
        <img class="av-brand-mini" src="../assets/logoAvalizeBranca.png" alt="Avalize" style="height: 30px; width: auto;">
      </div>

      <v-list dense  class="py-0">
        <v-list-item  to='/home' @click="textoMenu = 'Dashboard'" active-class="corMenu" v-if="user.tipo != 'FORNECEDOR' && user.tipo != 'SUPERVISOR'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/empresas' active-class="corMenu" @click="textoMenu = 'Empresas'" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">mdi-domain</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Empresas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/planos' active-class="corMenu" @click="textoMenu = 'Planos'" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">mdi-tag-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Planos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/usuarios' active-class="corMenu" @click="textoMenu = 'Usuários'" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/auditoria' active-class="corMenu" @click="textoMenu = 'Auditoria'" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">mdi-clipboard-text-clock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Auditoria</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/pesquisas' active-class="corMenu" @click="textoMenu = 'Questionários'" v-if="user.tipo!='FORNECEDOR'&&user.tipo!='SUPERVISOR'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">question_answer</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Pesquisas NPS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/dispositivos' active-class="corMenu" @click="textoMenu = 'Dispositivos'" v-if="user.tipo != 'FORNECEDOR' && user.tipo != 'SUPERVISOR'">
         <v-list-item-action>
           <v-icon dense medium class="av-menu-icon">tablet_android</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Dispositivos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/respostas' active-class="corMenu" @click="textoMenu = 'Respostas'" v-if="user.tipo != 'FORNECEDOR' && user.tipo != 'SUPERVISOR'">
         <v-list-item-action>
           <v-icon dense medium class="av-menu-icon">mdi-forum-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Respostas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/avaliacoes' active-class="corMenu" @click="textoMenu = 'Avaliações'" v-if="user.tipo != 'FORNECEDOR' && user.tipo != 'SUPERVISOR'">
         <v-list-item-action>
           <v-icon dense medium class="av-menu-icon">mdi-chart-line-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Avaliações</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/upload' active-class="corMenu" @click="textoMenu = 'Upload'" v-if="user.tipo == 'SUPERVISOR'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">upload</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Upload</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/estoque' active-class="corMenu" @click="textoMenu = 'Estoque'" v-if="user.tipo == 'SUPERVISOR' || user.tipo == 'FORNECEDOR'">
          <v-list-item-action>
            <v-icon dense medium class="av-menu-icon">book</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Estoque</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider class="av-menu-divider"></v-divider>
        <v-list-item href='https://wa.me/558335125222' target="_blank" active-class="corMenu" @click="textoMenu = 'Suporte'">
          <v-list-item-action>
            <img src="../assets/icon-suporte-fechado.png">
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="av-menu-title">Suporte</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <v-app-bar app clipped-left flat v-if="usuarioLogado" color="white" height="64" style="border-bottom: 1px solid #e3e7e7;">
      <v-app-bar-nav-icon  @click.stop="toggleSidebar" style="color:#2c3a3a;"></v-app-bar-nav-icon>
      <div class="bar-heading" v-if="$route.meta && $route.meta.title">
        <div class="bar-title">{{ $route.meta.title }}</div>
        <div class="bar-subtitle" v-if="$route.meta.subtitle">{{ $route.meta.subtitle }}</div>
      </div>
      <v-spacer></v-spacer>
      <!-- MENU USUÁRIO -->
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar size="40">
              <v-img v-if="fotoUsuario" :src="fotoUsuario"></v-img>
              <v-icon v-else large color="#2c3a3a">account_circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item>
            <v-list-item-avatar>
              <v-img v-if="fotoUsuario" :src="fotoUsuario"></v-img>
              <v-icon v-else large light>account_circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-weight: bold;color: grey;">{{user.nome}}</v-list-item-title>
              <v-list-item-subtitle>{{companyobj.nome}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item  @click.stop="abrirEditarUsuario()">
            <v-list-item-title>Editar usuário</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="abrirAlterarSenha()">
            <v-list-item-title>Alterar senha</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="Sair()">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- DIALOG EDITAR USUÁRIO (perfil próprio) -->
    <v-dialog v-model="dialogoPerfil" persistent max-width="520px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">Editar usuário</v-card-title>
        <p class="av-dialog-hint">* indica preenchimento obrigatório</p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <span class="av-section-label">Dados do usuário</span>
          <v-row class="av-form-row">
            <v-col cols="12">
              <label class="av-field-label">Nome <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="perfilEdit.nome"></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="av-field-label">E-mail <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="perfilEdit.email"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoPerfil = false">Cancelar</v-btn>
          <v-btn depressed color="primary" :disabled="!podeSalvarPerfil" @click="salvarPerfil">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG ALTERAR SENHA (fluxo próprio, exige a senha atual) -->
    <v-dialog v-model="dialogoSenha" persistent max-width="520px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">Alterar senha</v-card-title>
        <p class="av-dialog-hint">* indica preenchimento obrigatório</p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <span class="av-section-label">Senha de acesso</span>
          <v-row class="av-form-row">
            <v-col cols="12">
              <label class="av-field-label">Senha atual <span class="req">*</span></label>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="senhaEdit.senhaAtual"
                :type="mostrarSenhaAtual ? 'text' : 'password'"
                :append-icon="mostrarSenhaAtual ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="mostrarSenhaAtual = !mostrarSenhaAtual"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="av-field-label">Nova senha <span class="req">*</span></label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                v-model="senhaEdit.novaSenha"
                :type="mostrarNovaSenha ? 'text' : 'password'"
                :append-icon="mostrarNovaSenha ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="mostrarNovaSenha = !mostrarNovaSenha"
                hint="Mínimo de 6 caracteres"
                persistent-hint
                :error-messages="erroNovaSenha"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="av-field-label">Confirmar nova senha <span class="req">*</span></label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                v-model="senhaEdit.confirmarSenha"
                :type="mostrarConfirmarSenha ? 'text' : 'password'"
                :append-icon="mostrarConfirmarSenha ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="mostrarConfirmarSenha = !mostrarConfirmarSenha"
                :error-messages="erroConfirmacao"
                :success-messages="okConfirmacao"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoSenha = false">Cancelar</v-btn>
          <v-btn depressed color="primary" :disabled="!podeSalvarSenha" @click="salvarSenha">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="av-snackbar-host">
      <Snackbar ref="chamaSnackbar" />
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" color="#2f7d74" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    components: { Snackbar, Loading },
    props: {
      source: String,
    },

    data() {
      return {
        company: [],
        /* user: [], */
        isLoading: false,
        fullPage: true,
        dialogoPerfil: false,
        perfilEdit: {
          nome: '',
          email: '',
        },
        dialogoSenha: false,
        senhaEdit: {
          senhaAtual: '',
          novaSenha: '',
          confirmarSenha: '',
        },
        mostrarSenhaAtual: false,
        mostrarNovaSenha: false,
        mostrarConfirmarSenha: false,
        textoMenu: 'Dashboard',
        drawer: null,
        items: [
          { title: 'Home', icon: 'dashboard' },
          { title: 'About', icon: 'question_answer' },
        ],
        clipped: true,
        mini: false,
        right: null,
        title: 'Controle de Clientes',
      }
    },

    created () {
      const salvo = localStorage.getItem('sidebarMini')
      if (salvo !== null) this.mini = salvo === '1'
    },

    mounted: function () {
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
      if (sessionStorage.getItem('user') != null)
        this.$store.dispatch('SetUser')
      if (sessionStorage.getItem('company') != null)
        this.$store.dispatch('SetCompany')
    },

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj
      }),
      // Só renderiza a <v-img> quando `imagem` é um link de imagem de verdade.
      // Sem foto (undefined/null/''), ou um valor que não seja link, cai no
      // ícone padrão — antes, `imagem != ''` dava true para undefined e tentava
      // exibir uma imagem vazia.
      fotoUsuario() {
        var img = this.user && this.user.imagem
        return (typeof img === 'string' && /^(https?:\/\/|data:image\/)/.test(img)) ? img : ''
      },
      // Habilita o Salvar do perfil só com nome e e-mail preenchidos E quando
      // algo mudou em relação ao usuário atual (evita salvar sem alteração).
      podeSalvarPerfil() {
        var nome = (this.perfilEdit.nome || '').trim()
        var email = (this.perfilEdit.email || '').trim()
        if (!nome || !email) return false
        var u = this.user || {}
        return nome !== (u.nome || '') || email !== (u.email || '')
      },
      // Validações inline do dialog de alteração de senha.
      erroNovaSenha() {
        var s = this.senhaEdit.novaSenha
        return (s && s.length < 6) ? 'Mínimo de 6 caracteres' : ''
      },
      erroConfirmacao() {
        var e = this.senhaEdit
        return (e.confirmarSenha && e.confirmarSenha !== e.novaSenha) ? 'As senhas não conferem' : ''
      },
      okConfirmacao() {
        var e = this.senhaEdit
        return (e.confirmarSenha && e.confirmarSenha === e.novaSenha) ? 'As senhas conferem' : ''
      },
      // Habilita o Salvar só com os três campos preenchidos, nova senha com ao
      // menos 6 caracteres e confirmação idêntica.
      podeSalvarSenha() {
        var e = this.senhaEdit
        return !!e.senhaAtual &&
          e.novaSenha.length >= 6 &&
          e.confirmarSenha === e.novaSenha
      },
    },

    methods: {
      toggleSidebar() {
        // Mobile: abre/fecha o drawer. Desktop: alterna entre expandida e recolhida (e lembra)
        if (this.$vuetify.breakpoint.smAndDown) {
          this.drawer = !this.drawer
        } else {
          this.mini = !this.mini
          localStorage.setItem('sidebarMini', this.mini ? '1' : '0')
        }
      },

      Sair() {
        this.$store.dispatch('Sair')
        this.$router.push({ path: '/login' })
      },

      // Extrai a mensagem amigável devolvida pelo backend (LoopBack: error.message).
      mensagemErro(err, padrao) {
        var resp = err && err.response && err.response.data
        if (resp && resp.error && resp.error.message) return resp.error.message
        return padrao
      },

      abrirEditarUsuario() {
        this.perfilEdit = {
          nome: this.user.nome || '',
          email: this.user.email || '',
        }
        this.dialogoPerfil = true
      },

      async salvarPerfil() {
        var vm = this
        if (!this.perfilEdit.nome || !this.perfilEdit.email) {
          vm.$refs.chamaSnackbar.snack('warning', 'Preencha nome e e-mail para prosseguir', 'white')
          return
        }
        this.isLoading = true
        var payload = {
          nome: this.perfilEdit.nome,
          email: this.perfilEdit.email,
        }
        await axios.post(baseApiUrl + 'Usuarios/atualizarPerfil?access_token=' + sessionStorage.getItem('accToken'), payload)
        .then(response => {
          this.isLoading = false
          if (response.data) {
            // Mescla os campos atualizados no usuário guardado e reflete no store.
            var atualizado = Object.assign({}, this.user, {
              nome: response.data.nome,
              email: response.data.email,
            })
            sessionStorage.setItem('user', JSON.stringify(atualizado))
            sessionStorage.setItem('userName', atualizado.nome)
            this.$store.dispatch('SetUser')
            this.$store.dispatch('SetUserName')
            this.dialogoPerfil = false
            vm.$refs.chamaSnackbar.snack('success', 'Perfil atualizado com sucesso!', 'white')
          }
        })
        .catch(err => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack('#FEC8C8', this.mensagemErro(err, 'Erro ao atualizar o perfil'), '#BF4554')
        })
      },

      abrirAlterarSenha() {
        this.senhaEdit = {
          senhaAtual: '',
          novaSenha: '',
          confirmarSenha: '',
        }
        this.mostrarSenhaAtual = false
        this.mostrarNovaSenha = false
        this.mostrarConfirmarSenha = false
        this.dialogoSenha = true
      },

      async salvarSenha() {
        var vm = this
        var s = this.senhaEdit
        if (!s.senhaAtual || !s.novaSenha || !s.confirmarSenha) {
          vm.$refs.chamaSnackbar.snack('warning', 'Preencha todos os campos de senha', 'white')
          return
        }
        if (s.novaSenha.length < 6) {
          vm.$refs.chamaSnackbar.snack('warning', 'A nova senha deve ter ao menos 6 caracteres', 'white')
          return
        }
        if (s.novaSenha !== s.confirmarSenha) {
          vm.$refs.chamaSnackbar.snack('warning', 'A confirmação não confere com a nova senha', 'white')
          return
        }
        this.isLoading = true
        // Endpoint nativo do model User do LoopBack: verifica a senha atual
        // (oldPassword) e opera sempre sobre o usuário do próprio token.
        await axios.post(baseApiUrl + 'Usuarios/change-password?access_token=' + sessionStorage.getItem('accToken'), {
          oldPassword: s.senhaAtual,
          newPassword: s.novaSenha,
        })
        .then(() => {
          this.isLoading = false
          this.dialogoSenha = false
          vm.$refs.chamaSnackbar.snack('success', 'Senha alterada com sucesso!', 'white')
        })
        .catch(err => {
          this.isLoading = false
          // O nativo devolve "Invalid current password" (code INVALID_PASSWORD)
          // em inglês — para esse caso a tradução PT tem prioridade sobre a
          // mensagem do backend. Nos demais (ex.: mínimo de 6, que o hook já
          // devolve em PT) usa a mensagem do backend.
          var resp = err && err.response && err.response.data
          var msg = (resp && resp.error && resp.error.code === 'INVALID_PASSWORD')
            ? 'Senha atual incorreta.'
            : this.mensagemErro(err, 'Erro ao alterar a senha')
          vm.$refs.chamaSnackbar.snack('#FEC8C8', msg, '#BF4554')
        })
      },

      menuListaCli() {
        this.$router.push({ path: '/lista' })
      },

      menuListaAtend() {
        this.$router.push({ path: '/tipoatend' })
      },

      menuSair() {
        this.$router.push({ path: '/' })
      },

      menuPainels() {
        this.$router.push({ path: '/paineis' })
      },
    }
  }
</script>

<style>
  .v-navigation-drawer .v-list .v-list__tile {
    text-decoration: none;
    color: white;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .v-divider{
    margin-top: 0%;
    margin-bottom: 0%;
  }

  /* Divisor sutil acima do Suporte */
  .av-menu-divider.v-divider {
    border-color: rgba(255, 255, 255, 0.10) !important;
    margin: 6px 0;
  }

  /* Marca do projeto no topo da barra */
  .av-brand {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .av-brand-full {
    height: 30px;
    width: auto;
    max-width: 86%;
  }

  .av-brand-mini {
    height: 30px;
    width: auto;
    display: none;
  }

  .v-navigation-drawer--mini-variant .av-brand {
    padding: 14px 0;
  }

  .v-navigation-drawer--mini-variant .av-brand-full {
    display: none;
  }

  .v-navigation-drawer--mini-variant .av-brand-mini {
    display: block;
  }

  /* Itens do menu lateral — superfícies planas, no padrão das demais telas */
  .v-navigation-drawer .v-list-item {
    margin: 0;
    min-height: 48px;
    border-radius: 0;
    border-left: 3px solid transparent;
    transition: background-color .15s ease, color .15s ease, border-color .15s ease;
  }

  .v-navigation-drawer .av-menu-icon {
    color: rgba(255, 255, 255, 0.65) !important;
    transition: color .15s ease;
  }

  .v-navigation-drawer .av-menu-title {
    color: rgba(255, 255, 255, 0.72);
    font-size: 14px;
    font-weight: 500;
    letter-spacing: .2px;
    word-wrap: break-word;
    transition: color .15s ease;
  }

  /* Hover: realce de linha sutil (como o hover das tabelas) */
  .v-navigation-drawer .v-list-item:hover {
    background-color: rgba(255, 255, 255, 0.06);
  }

  .v-navigation-drawer .v-list-item:hover .av-menu-icon,
  .v-navigation-drawer .v-list-item:hover .av-menu-title {
    color: #ffffff !important;
  }

  /* Item ativo: faixa de acento à esquerda (como o stripe dos cards) + realce sutil */
  .corMenu,
  .corMenu:hover {
    background-color: rgba(255, 255, 255, 0.10) !important;
    border-left: 3px solid #3ba8a2 !important;
  }

  .corMenu .av-menu-icon,
  .corMenu .av-menu-title {
    color: #ffffff !important;
  }

  .corMenu .av-menu-title {
    font-weight: 600;
  }

  /* Estado recolhido (rail): ícone centralizado, faixa de acento à esquerda */
  .v-navigation-drawer--mini-variant .v-list-item {
    justify-content: center;
    padding: 0 12px !important;
    min-height: 48px;
  }

  .v-navigation-drawer--mini-variant .v-list-item__action,
  .v-navigation-drawer--mini-variant .v-list-item__icon {
    margin: 0 !important;
    min-width: 0 !important;
    justify-content: center;
  }


  .bar-heading {
    margin-left: 8px;
    line-height: 1.25;
  }

  .bar-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2a2a;
  }

  .bar-subtitle {
    font-size: 12px;
    color: #5f6b6b;
  }

  .imagemLogo {
    position:absolute;
    right:50%;
    left:50%;
    margin-right:-50px;
    margin-left:-50px;
  }

  .textomenu {
    font-size: 15px;
    position: absolute;
    left:5%;
    color: white;
    /* margin-right:-50px; */
    margin-left: -20px;
  }

  hr {
    border: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.75),
    rgba(255, 255, 255, 0)
    );
  }

  .titulosmenu {
    font-weight: bold;
    color: grey;
  }

  /* Dialogs de perfil / senha — mesma linguagem dos dialogs das telas
     (ver Empresas.vue). Bloco global de propósito: o conteúdo do v-dialog é
     movido para fora do componente, então estilos scoped não o alcançariam. */
  /* O Vuetify escopa suas regras sob `.v-application`, então um seletor de
     classe global empata/perde por ordem de carga. Como o toolbar não é
     scoped, forço com !important (restrito ao dialog) e achato a altura do
     título (o .v-card__title é flex com line-height 2rem por padrão). */
  .v-dialog .av-dialog-title.v-card__title {
    display: block !important;
    font-size: 17px !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    color: var(--av-text);
    padding: 16px 16px 0 !important;
  }

  .v-dialog .av-dialog-hint {
    margin: 0 !important;
    padding: 2px 16px 12px !important;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin: 4px 0 10px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-field-label .req {
    color: #c62828;
  }

  .av-field-hint {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: var(--av-text-soft);
  }

  /* Respiro confortável entre os campos do formulário */
  .av-form-row > [class*="col"] {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  /* A snackbar compartilhada usa `absolute`, e o Vuetify 2.7 aplica
     `.v-snack--absolute { position: absolute; z-index: 1 }` — z-index 1 fica
     muito abaixo da v-app-bar fixa, então a mensagem sumia atrás dela.
     Só para esta instância (classe do elemento nesta versão é `.v-snack`):
     volta a `fixed` com z-index alto e começa em 64px, abaixo da app-bar. */
  .av-snackbar-host .v-snack {
    position: fixed !important;
    z-index: 1000 !important;
    top: 64px !important;
    bottom: 0 !important;
    height: auto !important;
  }
</style>
